import {
  IconBan,
  IconCheck,
  IconClock,
  IconCustomBoltRestore,
  IconCustomBorderCornersRestore,
  IconCustomFolderMove,
  IconDownload,
  IconLink,
  IconMailShare,
  IconPlayerSkipBack,
  IconPlayerSkipForward,
  IconTrash,
  TablerIcon,
} from '@rossum/ui/icons/tabler';
import { SvgIcon, SvgIconProps } from '@rossum/ui/material';
import { SidebarFooterActionId } from './utils';

const actionIcons: Record<SidebarFooterActionId, TablerIcon> = {
  postpone: IconClock,
  reject: IconBan,
  bypass: IconCheck,
  move: IconCustomFolderMove,
  link: IconLink,
  email: IconMailShare,
  download: IconDownload,
  reExtract: IconCustomBorderCornersRestore,
  reAutomate: IconCustomBoltRestore,
  delete: IconTrash,
  next: IconPlayerSkipForward,
  previous: IconPlayerSkipBack,
};

type SidebarFooterActionIconProps = SvgIconProps & {
  actionId: SidebarFooterActionId;
};

export const SidebarFooterActionIcon = ({
  actionId,
  ...rest
}: SidebarFooterActionIconProps) => {
  const Icon = actionIcons[actionId];

  if (!Icon) {
    return null;
  }

  return (
    <SvgIcon fontSize="large" {...rest}>
      <Icon />
    </SvgIcon>
  );
};
